import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from '../../Contexts/main.context';
import { ClientContext } from '../../Contexts/client.context';

const ClientNavBar = ({ clients = [] }) => {
     const { activeOutlet, originalID, updateOriginalID, updateActiveClient, updateActiveOutlet, updateMyAccount } = useContext(AccountContext);
     const { updateClientlocation } = useContext(ClientContext);
     const navigate = useNavigate();

     useEffect(() => {
          const location = clients.find(client => String(client.ID) === String(originalID));
          if (location) updateActiveClient(location);
     }, [originalID, clients, updateActiveClient]);

     const chooseLocation = (id) => {
          const location = clients.find(client => String(client.ID) === id);
          if (!location) return;
          updateOriginalID(id);
          updateActiveClient(location);
          updateActiveOutlet('Citations');
     };
     const signOut = () => {
          localStorage.removeItem('LGOUser');
          updateMyAccount({});
          updateActiveClient(null);
          updateOriginalID('');
          updateActiveOutlet('Locations');
          updateClientlocation([]);
          navigate('/login', { replace: true });
     };

     return (
          <nav className="client-navbar" aria-label="Client navigation">
               <div className="client-location-picker">
                    <label htmlFor="client-location" className="text-white">Location</label>
                    <select id="client-location" className="form-select" value={clients.some(client => String(client.ID) === String(originalID)) ? originalID : ''} onChange={event => chooseLocation(event.target.value)}>
                         <option value="" disabled>Choose location</option>
                         {clients.map(client => <option key={client.ID} value={client.ID}>{client.theLocation}</option>)}
                    </select>
               </div>
               <div className="client-nav-actions">
                    <button type="button" className="btn btn-outline-light" onClick={() => updateActiveOutlet('Locations')}>Locations</button>
                    <button type="button" className="btn btn-danger" onClick={signOut}>Sign out</button>
               </div>
          </nav>
     );
};
export default ClientNavBar;
